// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TAAw","left":"styles_left__1_v9Z"};